// Add to cart function - can be called inline from button onclick
function addToCartFromButton(button) {
  // Get data attributes from button
  const variantId = button.getAttribute('data-variant-id');
  const quantity = button.getAttribute('data-quantity') || '1';
  const sellingPlanId = button.getAttribute('data-selling-plan-id');
  
  // Validate variant ID exists
  if (!variantId) {
    return;
  }
  
  // Check if routes object exists
  const routes = window.routes || routes;
  if (!routes || !routes.cart_add_url) {
    return;
  }
  
  // Disable button and show loading state
  button.disabled = true;
  button.classList.add('loading');
  const spinner = button.querySelector('.loading__spinner');
  if (spinner) {
    spinner.classList.remove('hidden');
  }
  
  // Prepare form data
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);
  
  // Add selling plan if available
  if (sellingPlanId) {
    formData.append('selling_plan', sellingPlanId);
  }
  
  // Add sections for cart drawer refresh
  formData.append('sections', 'cart-drawer');
  formData.append('sections_url', window.location.pathname);
  
  // Prepare fetch config - match Shopify's product-form.js approach
  // Use fetchConfig if available, otherwise create similar config
  let config;
  if (typeof fetchConfig === 'function') {
    config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
  } else {
    config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      }
    };
  }
  config.body = formData;
  
  // Helper function to handle response
  function handleResponse(response) {
    // Check response status first
    if (!response.ok && response.status !== 0) {
      // If not ok, try to get error message
      return response.text().then(text => {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      });
    }
    
    // Check content type
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      // It's JSON, parse it
      return response.json();
    } else if (contentType.includes('application/javascript')) {
      // It's JavaScript (Shopify's format), parse as JSON
      return response.text().then(text => {
        try {
          return JSON.parse(text);
        } catch (e) {
          throw new Error('Invalid JSON response');
        }
      });
    } else {
      // Try to parse as JSON anyway (sometimes content-type header is missing)
      return response.text().then(text => {
        // Check if it looks like HTML
        if (text.trim().toLowerCase().startsWith('<!doctype') || text.trim().toLowerCase().startsWith('<html')) {
          throw new Error('Server returned HTML instead of JSON. Check variant ID and selling plan ID.');
        }
        
        // Try to parse as JSON
        try {
          return JSON.parse(text);
        } catch (e) {
          throw new Error('Invalid JSON response');
        }
      });
    }
  }
  
  // Make request
  fetch(routes.cart_add_url, config)
    .then(response => handleResponse(response))
    .then(response => {
      // Check for error status in response
      if (response.status) {
        // Error occurred
        button.disabled = false;
        button.classList.remove('loading');
        if (spinner) {
          spinner.classList.add('hidden');
        }
        return;
      }
      
      // Success - refresh cart drawer
      refreshCartDrawer();
      
      // Re-enable button
      button.disabled = false;
      button.classList.remove('loading');
      if (spinner) {
        spinner.classList.add('hidden');
      }
    })
    .catch(error => {
      button.disabled = false;
      button.classList.remove('loading');
      if (spinner) {
        spinner.classList.add('hidden');
      }
    });
}

// Refresh cart drawer function
function refreshCartDrawer() {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", `${window.routes.cart_url}?section_id=cart-drawer`, true);
  xhr.onload = function () {
    if (xhr.status === 200) {
      const html = new DOMParser().parseFromString(xhr.responseText, 'text/html');
      
      // Store reference to current cart drawer for smooth transition
      const currentCartDrawer = document.querySelector('#CartDrawer');
      
      // Remove the `drawer__inner-empty` element if it exists
      const emptyElement = document.querySelector('.drawer__inner-empty');
      if (emptyElement) {
        emptyElement.remove();
      }

      // Remove the `is-empty` class from the `cart-drawer` element if it exists
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }

      // Add smooth transition before replacement
      if (currentCartDrawer) {
        currentCartDrawer.style.transition = 'opacity 0.1s ease';
        currentCartDrawer.style.opacity = '0.8';
      }

      // Replace the content using the same approach as addCart function
      const selectors = ['#CartDrawer'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }

      // Immediately restore opacity and open cart drawer
      const newCartDrawer = document.querySelector('cart-drawer');
      const newCartDrawerContent = document.querySelector('#CartDrawer');
      
      if (newCartDrawerContent) {
        newCartDrawerContent.style.opacity = '1';
        newCartDrawerContent.style.transition = '';
      }
      
      if (newCartDrawer) {
        newCartDrawer.classList.add('active');
      }

      // Minimal delay with optimized event triggering
      requestAnimationFrame(() => {
        // Trigger only the essential event first
        document.dispatchEvent(new CustomEvent('cart:refreshed'));
        
        // Then trigger additional events on next frame
        requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        });
      });
    }
  };

  xhr.onerror = function () {
    // Error handled silently
  };

  xhr.send();
}

document.addEventListener('DOMContentLoaded', function() {
  const radioInputs = document.querySelectorAll('.nw-notrace-option-radio input[type="radio"]');
  
  radioInputs.forEach(input => {
    input.addEventListener('change', function() {
      const blockParent = this.closest('.nw-notrace-option-block-onetime');
      const targetImage = this.getAttribute('data-image');
      const selectedQuantity = this.getAttribute('data-quantity');
      const images = blockParent.querySelectorAll('.nw-notrace-option-block-image');
      
      // Toggle images
      images.forEach(img => {
        img.style.display = 'none';
      });
      
      const showImage = blockParent.querySelector(`.nw-notrace-option-block-image[data-option="${targetImage}"]`);
      if (showImage) {
        showImage.style.display = 'block';
      }
      
      // Update button quantity
      const oneTimeButton = blockParent.querySelector('button[data-one-time-button]');
      if (oneTimeButton && selectedQuantity) {
        oneTimeButton.setAttribute('data-quantity', selectedQuantity);
      }
    });
  });
});

